// @givmo/app-admin — charity identity cell (logo + name + website link + category).
//
// Shared by THREE dashboard sections — the approvals table, the top-charities panel, and the
// "Company gave" table's single-charity rows — which is why it lives on its own rather than inside any
// one of them. Extracted VERBATIM from `dashboard-page.tsx` (EP-W1 PR1); markup unchanged.

import { Avatar, Badge, Icon } from '@givmo/design-system';
import { ExternalLink } from 'lucide-react';
import type { CharityOut } from '@givmo/api-client';
import { charityWebsiteHref } from '../dashboard-decode';

export function CharityCell({ charity }: { charity: CharityOut }) {
  const href = charityWebsiteHref(charity);
  return (
    <div className="flex min-w-0 items-center gap-10">
      <Avatar src={charity.logo_url} name={charity.name} size="sm" />
      <div className="flex min-w-0 flex-col items-start gap-3">
        <div className="flex items-center gap-6">
          <span className="truncate font-w600 text-text-strong">{charity.name}</span>
          {href !== null ? (
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={`Visit ${charity.name} website`}
              className="shrink-0 text-text-tertiary outline-none transition-colors hover:text-brand-600 focus-visible:text-brand-600"
              onClick={(e) => e.stopPropagation()}
            >
              <Icon icon={ExternalLink} size={13} aria-hidden />
            </a>
          ) : null}
        </div>
        {charity.category != null && charity.category.length > 0 ? (
          <Badge tone="neutral" size="sm">
            {charity.category}
          </Badge>
        ) : null}
      </div>
    </div>
  );
}
